module.exports = __webpack_public_path__ + "pc-static/img/my_avatar.9d8892e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/my_avatar.png
// module id = QpEx
// module chunks = 1